<script>
	import { page } from '$app/stores';
	import { clickOutside } from '$lib/utils/click_outside';
	import Loader from '$lib/components/Loader.svelte';
	import { variables } from '$lib/variables';

	let Open;
	const ChangeLang = (lang) => {
		load = true;
		fetch(`/lang`, {
			method: 'POST',
			body: JSON.stringify({ host: lang })
		})
			.then((response) => {})
			.then((data) => {})
			.catch((error) => {
				console.error('Ошибка при отправке запроса2:', error);
			});

		setTimeout(() => {
			location.href = $page.url.pathname;
		}, 1000);

		Open = false;
	};
	let load = false;
</script>

{#if load}
	<Loader />
{/if}
<div
	use:clickOutside
	on:outclick={() => {
		Open = false;
	}}
	class="relative inline-block text-left"
>
	<div>
		<button
			on:click={() => {
				Open = !Open;
			}}
			type="button"
			class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-none px-2 py-1 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-white"
			id="menu-button"
			aria-expanded="true"
			aria-haspopup="true"
		>
			{$page.data.host || 'ru'}
		</button>
	</div>
	{#if Open}
		<div
			class="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
			role="menu"
			aria-orientation="vertical"
			aria-labelledby="menu-button"
			tabindex="-1"
		>
			{#each ['ru', 'en', 'kz', 'arm'] as item}
				<div
					on:click={() => {
						ChangeLang(item);
					}}
					class="py-1 flex justify-between items-center px-2"
					role="none"
				>
					<!-- Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" -->
					{#if item != 'ru'}
						<button
							class="text-gray-700 block px-4 py-2 text-sm"
							role="menuitem"
							tabindex="-1"
							id="menu-item-0">{item}</button
						>
						{#if item === 'en'}
							<img width="24" height="auto" src="/Flag-United-Kingdom.webp" alt="" />
						{/if}
						{#if item === 'kz'}
							<img width="24" height="auto" src="/kz.png" alt="" />
						{/if}
						{#if item === 'arm'}
							<img width="24" height="auto" src="/Flag_of_Armenia.svg.png" alt="" />
						{/if}
					{:else}
						<button
							class="text-gray-700 block px-4 py-2 text-sm"
							role="menuitem"
							tabindex="-1"
							id="menu-item-0">{item}</button
						>
						<img width="24" height="auto" src="/flag-of-russia-.png" alt="" />
					{/if}
				</div>
			{/each}
		</div>
	{/if}
</div>
